import { Injectable } from '@angular/core';
import { PaymentCardReaderModel } from '../entity/paymentCardReader.model';
import { PaymentCardReaderRepository } from '../../impl/service/repository/paymentCardReader.repository';
import { PaymentCardReaderSummaryDataServiceAdapter } from '../../impl/service/repository/paymentCardReaderSummary.dataserviceadapter';
import { AbstractFindManyPaginatedService } from 'src/app/modules/core/service/v2/service/findmany/abstractFindManyPaginated.service';
import { PaymentCardReaderSummaryModel } from '../entity/paymentCardReaderSummary.model';
import {PaymentCardReaderDataServiceAdapter} from "../../impl/service/repository/paymentCardReader.dataserviceadapter";

@Injectable()
export class PaymentCardReaderFindManyPaginatedService extends AbstractFindManyPaginatedService<PaymentCardReaderModel, PaymentCardReaderModel> {
    constructor(repository: PaymentCardReaderRepository, dataServiceAdapter: PaymentCardReaderDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}
